/**
 * ============================================================
 *  CONFIG · CALCULADORA DE FINANCIAMIENTO UNEMI
 * ============================================================
 *  Este archivo controla TODO lo relacionado a la calculadora.
 *  Puedes editarlo libremente sin tocar el resto de la app.
 *
 *  - Para DESACTIVAR la calculadora en toda la web:
 *      pon `enabled: false` (o comenta el import donde se usa).
 *
 *  - Para ajustar plazos, descuentos, % sugerido inicial,
 *    modalidades habilitadas o textos, edita los valores abajo.
 * ============================================================
 */

export const CALCULADORA_CONFIG = {
    // Activa/desactiva la calculadora globalmente (Home, Detalle, Financiamiento)
    enabled: true,

    // Modalidades disponibles ("diferido" = cuotas | "contado" = pago único)
    modalidades: {
        diferido: true,
        contado: true,
    },

    // Modalidad seleccionada por defecto al cargar
    modalidadDefault: "diferido",

    // ---- DIFERIDO ----
    diferido: {
        // Rango de cuotas permitidas (mín. 2, máx. 24)
        minCuotas: 2,
        maxCuotas: 24,
        // Plazo seleccionado por defecto
        plazoDefault: 12,
        // % de cuota inicial sugerido al seleccionar maestría (0-100)
        porcentajeInicialSugerido: 20,
        // Descuento automático para plazos cortos (ej: $200 si pago en 2-10 cuotas)
        descuentoCuotasCortas: {
            enabled: true,
            monto: 200,        // ← cantidad descontada al valor del programa
            plazoMin: 2,       // ← desde N cuotas
            plazoMax: 10,      // ← hasta N cuotas
            etiqueta: "Promo plazo corto",
        },
    },

    // ---- CONTADO ----
    contado: {
        // ¿Mostrar el toggle "Aplicar descuento"?
        permitirDescuento: true,
        // Descuentos rápidos disponibles (en %)
        descuentosRapidos: [7, 15, 25],
        // Descuento seleccionado por defecto cuando se activa
        descuentoDefault: 25,
        // ¿Permitir descuento personalizado (input numérico)?
        permitirDescuentoPersonalizado: true,
    },

    // ---- TEXTOS (editable libremente) ----
    textos: {
        eyebrow: "Calculadora",
        titulo: "Tu plan de financiamiento",
        ctaInscribirse: "Quiero inscribirme",
        labelMaestria: "Maestría",
        labelFormaPago: "Forma de pago",
        labelDiferido: "Diferido",
        labelContado: "Contado",
        labelCuotaInicial: "Valor de inscripción",
        labelPlazo: "Plazo",
        labelAplicarDescuento: "Aplicar descuento",
        labelPorcentaje: "Porcentaje",
        labelCuotaMensual: "Cuota mensual estimada",
        labelPagoUnico: "Pago único de contado",
        labelSaldoFinanciar: "Saldo a financiar",
        labelTotalPagar: "Total a pagar",
        labelAhorro: "Ahorro",
        labelValorOriginal: "Valor original",
        labelValorPrograma: "Valor programa",
        labelCohorte: "Cohorte",
    },
};
